export default __webpack_public_path__ + "static/az-cdaf3ba8fc17b63ec6ff4688c69690b7.svg";